import deBounce from 'lodash.debounce'

document.addEventListener('DOMContentLoaded', function () {
    const newsLogosElements = document.querySelectorAll('.news-logos');
    if (!newsLogosElements.length) return;

    function checkAndApplyAnimation() {
        newsLogosElements.forEach((newsLogos, index) => {
            const wrapper = newsLogos.querySelector('.news-logos__wrapper');
            const logosContainer = newsLogos.querySelector('.news-logos__logos-container');

            if (wrapper && logosContainer) {
                const containerWidth = logosContainer.scrollWidth;
                const parentWidth = newsLogos.clientWidth - 60; // subtract extra for side gutter

                if (containerWidth > parentWidth) {
                    wrapper.classList.add('ticker-animation');
                } else {
                    wrapper.classList.remove('ticker-animation');
                }
            }
        });
    }

    const debouncedCheck = deBounce(checkAndApplyAnimation, 250);
    window.addEventListener('resize', debouncedCheck);


    // wait for all images to load before initial check
    const images = document.querySelectorAll('.news-logos img');
    let loadedImages = 0;

    function tryInitialize() {
        loadedImages++;
        if (loadedImages === images.length) {
            checkAndApplyAnimation();
        }
    }

    if (images.length > 0) {
        images.forEach(img => {
            if (img.complete) {
                tryInitialize();
            } else {
                img.addEventListener('load', tryInitialize);
            }
        });
    } else {
        checkAndApplyAnimation();
    }
});